import { render, staticRenderFns } from "./ProgressPage.vue?vue&type=template&id=06539584&scoped=true"
import script from "./ProgressPage.vue?vue&type=script&lang=js"
export * from "./ProgressPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06539584",
  null
  
)

export default component.exports